// extracted by mini-css-extract-plugin
export var askAiIcon = "_mk-j";
export var category = "_mk-9";
export var categoryHeader = "_mk-e";
export var container = "_mk-0";
export var group = "_mk-a";
export var groupItems = "_mk-f";
export var groupSeparator = "_mk-k";
export var loading = "_mk-1";
export var noResults = "_mk-3";
export var placeholder = "_mk-2";
export var resultContent = "_mk-5";
export var resultIcon = "_mk-c";
export var resultItem = "_mk-g";
export var resultMeta = "_mk-8";
export var resultSubtitle = "_mk-7";
export var resultSuffix = "_mk-i";
export var resultTitle = "_mk-6";
export var resultsList = "_mk-4";
export var searchGroup = "_mk-d";
export var selected = "_mk-h";
export var subgroup = "_mk-b";